<template>
  <div class="work">
    <Header title="外聘教师申请审核" ></Header>
    <router-view></router-view>
    <van-tabbar
      class="bottom-nav"
      v-model="active"
      active-color="#7469F8"
      inactive-color="#B3B9D0"
      route
    >
      <van-tabbar-item icon="like-o" replace to="/wpjsindex">
        <span class="nav-title">我的审核</span>
      </van-tabbar-item>
      <van-tabbar-item icon="like" replace to="/wpjsList">
        <span class="nav-title">审核记录</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0
    };
  },
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.bottom-nav {
  width: 100%;
  height: 49px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

  .nav-title {
    width: 22px;
    height: 16px;
    font-family: PingFangSC-Regular;
    font-size: 11px;
    letter-spacing: 0;
    text-align: center;
  }
}
</style>
<style lang="less">
.bottom-nav {
  .van-icon-like,
  .van-icon-like-o {
    font-family: "iconfont" !important;
    font-size: 26px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .van-icon-like::before {
    content: "\e6b7";
  }
  .van-icon-like-o::before {
    content: "\e6c0";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Examine/wpjsAudit/wpjsBar.vue